import { Component } from '@angular/core';

@Component({
  selector: 'app-good-distribution',
  templateUrl: './good-distribution.component.html',
  styleUrls: ['./good-distribution.component.scss']
})
export class GoodDistributionComponent {

}
